
import React from 'react';
import REVISION from '../../asserts/images/REVISION.jpeg';
import CULTURE from '../../asserts/images/CULTURE.jpg'
import vieetudiante from '../../asserts/images/vieetudiante.jpg';
import './VieAssociative.css';
const Box = (props) => (
  <div className="row row-cols-1 row-cols-md-3 g-4" >
    <div className="col" style={{width:'470px',height:'300px'}}>
      <div className="card h-100 position-relative"   style={{  width:'100%' }}>
        <img src={REVISION} className="card-img-top" alt="Card Image 3" style={{height:'600px',borderRadius:'5px'}}/>
        <div className="border p-3 d-inline-block text-center mx-auto position-absolute start-50 top-100 translate-middle rounded"
        style={{ background: 'orange', color: '#162533' }}>
        Vie Associative
        </div>
      </div>
    </div>
    <div className="col" style={{width:'470px',height:'300px'}}>
      <div className="card h-100 position-relative" style={{  width:'100%' }}>
        <img src={vieetudiante} className="card-img-top" alt="Card Image 3" style={{height:'600px',borderRadius:'5px'}}/>
        <div className="border p-3 d-inline-block text-center mx-auto position-absolute start-50 top-100 translate-middle rounded"
        style={{ background: 'orange', color: '#162533' }}>
          Vie Estudiantine
        </div>
      </div>
    </div>
    <div className="col" style={{width:'455px',height:'300px'}}>
      <div className="card h-100 position-relative" style={{  width:'100%' }}>
        <img src={CULTURE} className="card-img-top" alt="Card Image 3" style={{   height:'600px',borderRadius:'5px'}}/>
        <div className="border p-3 d-inline-block text-center mx-auto position-absolute start-50 top-100 translate-middle rounded " 
            style={{ background: 'orange', color: '#162533'}}>
            Vie culturelle
        </div>
    </div>
  </div>
  </div>

);

export default Box;